import { getProductInfo } from './api';
import { resolveReferralContext } from './deeplink';

/** 将接口商品行转为详情页使用的结构 */
export function normalizeProductRow(p, referralCode = '', gameGroupId = '') {
  if (!p) return null;
  let images = [];
  if (Array.isArray(p.images) && p.images.length) {
    images = p.images.filter((u) => typeof u === 'string' && u);
  } else if (typeof p.images === 'string' && p.images.trim()) {
    try {
      const parsed = JSON.parse(p.images);
      if (Array.isArray(parsed)) {
        images = parsed.filter((u) => typeof u === 'string' && u);
      }
    } catch {
      /* ignore */
    }
  }
  if (!images.length && p.src) {
    images = [p.src];
  }
  return {
    id: p.id,
    title: p.title,
    tg_title: p.tg_title,
    price: p.price,
    count: p.count,
    sell: p.sell,
    sendWay: p.sendWay,
    src: p.src || images[0] || '',
    images,
    cate_id: p.cate_id,
    link_key: p.link_key,
    detail: p.detail,
    product_type: p.product_type,
    referral_code: referralCode,
    gameGroupId: gameGroupId || undefined,
    gid: gameGroupId || undefined,
  };
}

/**
 * 从路由加载商品：优先 query.id / query.link_key，兼容旧版 /detail/:data JSON
 */
export async function loadProductForDetail(route) {
  const { referralCode, gameGroupId } = resolveReferralContext(route);

  if (route.params?.data) {
    try {
      const legacy = JSON.parse(route.params.data);
      return {
        detail: {
          ...legacy,
          referral_code: legacy.referral_code || referralCode,
          gameGroupId: legacy.gameGroupId || legacy.gid || gameGroupId || undefined,
          gid: legacy.gid || legacy.gameGroupId || gameGroupId || undefined,
        },
        referralCode: legacy.referral_code || referralCode,
        gameGroupId: legacy.gameGroupId || legacy.gid || gameGroupId || '',
      };
    } catch {
      /* 继续走 API */
    }
  }

  const linkKey = route.query?.link_key;
  const id = route.query?.id;

  if (!linkKey && (id === undefined || id === null || id === '')) {
    throw new Error('缺少商品 id 或 link_key');
  }

  const params = linkKey ? { link_key: String(linkKey) } : { id: String(id) };
  const res = await getProductInfo(params);
  const row = res?.data;
  if (!row) {
    throw new Error(res?.message || '商品不存在');
  }

  const detail = normalizeProductRow(row, referralCode, gameGroupId);
  return { detail, referralCode, gameGroupId };
}
